import React from 'react';
import Menubar from '../../components/Menubar';
import './Htmlhome.css';
import './Mobilehtmlhome.css';
import Play from './play.svg';
import Footer from '../../components/Footer.js';
import Csscard from '../../assets/CSS basics card.svg';
import Javascriptcard from '../../assets/Javascript basics card.svg';
import { Link } from 'react-router-dom';


const Htmlhome = () => {
    return (
      <div className='Htmlpagecontainer'>
        <div className='men'>
          <Menubar />
      </div>

        <div className='htmlhero' id='mobilehtmlhero'>
        <div className='coursehero'>
            <div className='title'>
                <h1>HTML Basics</h1>
                <p>If you are new to web development begin your coding journey with this markup language.</p>
            </div>
            <div className='titleintro'>
                <p>Difficulty level: Beginner</p>
                <p>Prerequisites : This course is for absolute beginners.</p>
            </div>
        </div>
        </div>

        <div className='takeaway'>
            <h3>Take Away Skills</h3>
            <ul>
                <li>You’ll learn the foundational skill to build web pages.</li>
                <li>You’ll learn to add and organise text, images, tables, lists and forms to your web pages.</li>
                <li>You’ll be develop understanding about the SEO friendly tags.</li>
            </ul>
        </div>

        <div className='whatyoulearn'>
            <h3>What You’ll Learn</h3>
            <div className='module'>
                <h4>Module 1 : Basics</h4>
                <p>In this module you will learn about the coding environment and syntax.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>What is HTML?</p>
                        <Link to = "/htmlm1l1"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Let's write some HTML code</p>
                        <Link to = "/htmlm1l2"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Elements and Tags</p>
                        <Link to = "/htmlm1l3"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Setting up development environment</p>
                        <Link to = "/htmlm1l4"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Coding in local environment</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>What this code is</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Boilerplate code + Emmet</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 2 : Elements & Tags</h4>
                <p>Learn some commonly used tags. Watch video lessons and code along.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>Heading element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Paragraph element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Anchor tag & attributes</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>The Image element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Nesting elements</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>div tag</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>List</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Table</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>HTML Forms</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>10</p>
                        <p>Empty elements</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 3 : Sementic Elements</h4>
                <p>These tags will help in making a website Search Engine friendly.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>Sementic elements</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Header element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Main element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Article contents element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Footer element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>The Document Title element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>The metadata element</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Favicon</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>Alt attribute</p>
                        <Link to = "/lesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
        </div>


        <div className='whatnext'>
            <h3>What Next</h3>
            
            <div className='whatnextgrid'>
                <div className='whatnextcol'>
                    <p>1</p>
                    <Link to='/css'><img src={Csscard} /></Link>
                </div>
                <div className='whatnextcol'>
                    <p>2</p>
                    <Link to='/js'><img src={Javascriptcard} /></Link>
                </div>
            </div>       
        </div>

        <div className='faq'>
        <h1>Frequently Asked Questions</h1>
        <div className='faqgrid'>
          <div className='faqcol'>
            <p>Q. Why should I learn HTML?</p>
            <p>A. HTML is the foundational language used in building a web page or web application.</p>
          </div>
          <div className='faqcol'>
            <p>Q. Is hard to learn HTML?</p>
            <p>A. Not at all. It is the easiest one.</p>
          </div>
          <div className='faqcol'>
            <p>Q. What is the recommended way to learn HTML?</p>
            <p>A. Read lessons and code along. Read the HTML 
            documentation. Build some website features and practice a lot. </p>
          </div>
        </div>
      </div>

      <Footer />

      </div>
      
    );
  };
  
  export default Htmlhome;